import React from "react";
import { motion } from "framer-motion";
import profileImage from "../assets/harshal-aglawe.jpeg";

const AboutSection = () => {
  const technologies = [
    { name: "C / C++", icon: "💻" },
    { name: "C#", icon: "🔷" },
    { name: "Java", icon: "☕" },
    { name: "JavaScript", icon: "🟨" },
    //{ name: "Python", icon: "🐍" },
    { name: "HTML", icon: "📄" },
    { name: "CSS", icon: "🎨" },
    { name: "React.js", icon: "⚛️" },
    { name: "Node.js", icon: "🟢" },
    { name: "Express.js", icon: "🚀" },
    { name: "SQL", icon: "🗄️" },
    { name: ".NET Core", icon: "🟣" },
    { name: "ASP.NET Web API", icon: "🌐" },
  ];

  // const otherSkills = [
  //   { name: "Bootstrap", icon: "🅱️" },
  //   { name: "Tailwind CSS", icon: "💨" },
  //   { name: "Material UI", icon: "📦" },
  //   { name: "Microservices Architecture", icon: "🏗️" },
  //   { name: "Clean Architecture", icon: "🧱" },
  //   { name: "Git", icon: "🔧" },
  //   { name: "GitHub", icon: "🐙" },
  //   { name: "Postman", icon: "📬" },
  //   { name: "VS Code", icon: "📝" },
  //   { name: "Canva", icon: "🎯" },
  // ];

  return (
    <section
      id="about"
      className="section-padding min-h-screen flex items-center
      bg-white dark:bg-gray-900 transition-colors duration-300"
    >
      <div className="container-custom w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-2 text-gray-900 dark:text-gray-100">
            <span className="text-teal-700 dark:text-accent">01.</span> About Me
          </h2>
          <div className="w-32 h-0.5 bg-teal-700 dark:bg-accent mb-8"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-start">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-4 md:col-span-3 text-sm"
          >
            <div className="text-gray-700 dark:text-gray-300 leading-relaxed space-y-3">
              <p>
                I began my programming journey with C, explored Python and C++,
                and gradually developed strong full-stack development skills
                using{" "}
                <span className="text-teal-700 dark:text-accent font-semibold">
                  MERN Stack
                </span>
                , building practical and impactful software applications.
              </p>

              <p>
                As an Intern Technologist in{" "}
                <span className="text-teal-700 dark:text-accent font-semibold">
                  .NET Backend Development
                </span>
                , I work on API development, database management, and
                understanding how scalable backend systems are designed in
                real-world environments.
              </p>
              <p>
                My goal is simple: keep learning, keep building real-world
                projects, and grow into a backend-focused full-stack developer
                who solves problems — not creates new ones.
              </p>
            </div>

            {/* Technologies */}
            <div className="mt-2 space-y-10">
              <div className="mt-8">
                <p className="text-gray-800 dark:text-gray-300 mb-4">
                  Technologies I work with
                </p>

                <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
                  {technologies.map((tech, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="flex items-center space-x-2 text-gray-700 dark:text-gray-300"
                    >
                      <span className="text-xl">{tech.icon}</span>
                      <span className="text-sm">{tech.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Tools */}
              {/* <div className="mt-0">
                <p className="text-gray-800 dark:text-gray-300 mb-4">
                  Tools & Architecture
                </p>

                <div className="grid grid-cols-3 md:grid-cols-5 gap-4">
                  {otherSkills.map((skill, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="flex items-center space-x-2 text-gray-700 dark:text-gray-300"
                    >
                      <span className="text-xl">{skill.icon}</span>
                      <span className="text-sm">{skill.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div> */}
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div
  initial={{ opacity: 0, x: 20 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6 }}
  className="
    relative 
    flex items-center justify-center 
    md:col-span-2
    mx-auto
    w-[80%]
  "
>
  <div className="relative w-full max-w-sm mx-auto">
    
    {/* L-shaped border */}
    <div
      className="
        absolute -top-4 -right-4 w-full h-full 
        border-t-2 border-r-2 
        border-teal-700 dark:border-accent
      "
    ></div>

    {/* Profile Picture */}
    <div
      className="
        relative bg-gray-200 dark:bg-gray-800 
        rounded-lg overflow-hidden 
        border-2 border-gray-300 dark:border-gray-700
      "
    >
      <div
        className="
          aspect-[3/4] 
          bg-gradient-to-br 
          from-gray-200 to-gray-300 
          dark:from-gray-700 dark:to-gray-800
        "
      >
        <img
          src={profileImage}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      </div>
    </div>

  </div>
</motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
